import { makeStyles } from '@material-ui/core/styles';

export type PMenuIconProps = {
  color?: string;
  white?: boolean;
  className?: any;
};

const useStyles = makeStyles(() => ({
  ico: {
    maxWidth: '100%',
  },
}));

export const useMenuIcon = (
  props: PMenuIconProps,
): { currentColor: string; classes: any } => {
  const classes = useStyles();
  const { color = '#7AC5F1', white } = props;
  const currentColor = white ? 'white' : color;
  return { currentColor, classes };
};
